import React,{useContext} from 'react'
import {SelectHostingContext} from "../state";

import Build from './build'
import Guide from './guide'


export const BUILD_PAGE = 'build';
export const GUIDE_PAGE = 'guid';


const PageSelector = () =>{
  const {state} = useContext(SelectHostingContext)
  const getSelectedPage = () => {
    return state && state.selectedTab
  }
  const renderPage = () =>{
    const selected = getSelectedPage()
    switch(selected){
      case BUILD_PAGE:
        return <Build/>
      case GUIDE_PAGE:
        return <Guide/>
      default:
        return (<></>)
    }

  }
  return (renderPage())
}

export default PageSelector